import type { AppDefinition } from '../../types/apps';

export const IntegrationsAppDefinition: AppDefinition = {
  appId: 'integrations',
  name: 'Integrations',
  version: '1.0.0',
  description: 'Connect external services — OAuth accounts, API keys, and MCP servers',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'PlugsConnected',
    phosphorWeight: 'duotone',
    color: '#0ea5e9',
  },
  supportedFileTypes: [],
  entityTypes: ['Integration', 'APIConnection', 'MCPConnection'],
  component: 'integrations',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  experimental: true,
};
